export enum ApcmStatuses {
  Active = 'active',
  Inactive = 'inactive',
  ReferralReceived = 'referral_received',
  PendingReview = 'pending_review',
  CallingQueue = 'calling_queue',
  PatientNoContact = 'patient_no_contact',
  Onboarding = 'onboarding',
}
